import { z } from 'zod';

export const editTPSchema = z.object({
  category: z.string().min(1),
  length: z.number().min(0).multipleOf(0.01),
  shielding: z.string().min(1),
});

export type EditTPSchema = z.infer<typeof editTPSchema>;
